<template>
  <div class="sidebar-logo-container">
    <!-- <transition name="sidebarLogoFade"> -->
      <router-link class="sidebar-logo-link" to="/">
        <img style="width: 100px ;height: 34px" :src="logoUrl ? logoUrl : require('@/assets/logo/logo.png')" class="sidebar-logo">
<!--        <img v-if="logo" style="width: 137px ;height: 46px"  :src="logoUrl ? logoUrl : require('@/assets/logo/logo.png')" class="sidebar-logo">-->
        <!-- <img v-if="logo" style="width: 137px ;height: 46px"  :src="require('@/assets/logo/lgoo2.png')" class="sidebar-logo"> -->
        <!--        <h1 v-else class="sidebar-title">{{ title }} </h1>-->
      </router-link>
      <!-- <router-link v-else key="expand" class="sidebar-logo-link" to="/"> -->
        <!-- <img v-if="logo" style="width: 100px ;height: 34px" :src="require('@/assets/logo/lgoo2.png')" class="sidebar-logo"> -->
        <!--        <h1 class="sidebar-title">{{ title }} </h1>-->
      <!-- </router-link> -->
    <!-- </transition> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	name: 'SidebarLogo',
	props: {
		collapse: {
			type: Boolean,
			required: true
		}
	},
	data () {
		return {
			title: 'Vue Element Admin',
			logo: '@/assets/login/loginlogo.png',
			login: false
		}
	},
	computed: {
		...mapState({
			// loginLogoUrl: (state) => state.user.loginLogoUrl,
			logoUrl: (state) => state.user.logoUrl
		})
	},
	created () {
		this.getLogo()
	},
	methods: {
		async getLogo () {
			await this.$store.dispatch('user/getLogo', {})
			this.login = true
		}
	}
}
</script>

<style lang="scss" scoped>
// .sidebarLogoFade-enter-active {
//   transition: opacity 1.5s;
// }

// .sidebarLogoFade-enter,
// .sidebarLogoFade-leave-to {
//   opacity: 0;
// }

.sidebar-logo-container {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #ffffff;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    display: block;
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 32px;
      height: 32px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 12px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  // &.collapse {
  //   .sidebar-logo {
  //     margin-right: 0px;
  //   }
  // }
}
</style>
